// extracted by mini-css-extract-plugin
export var sliderRange = "_cn-2";
export var sliderRoot = "_cn-0";
export var sliderThumb = "_cn-3";
export var sliderTrack = "_cn-1";